import {
  FETCH_ORG_DATA_START,
  FETCH_ORG_DATA_FULFILLED,
  FETCH_ORG_DATA_REJECTED,
  JOIN_ORG_START,
  JOIN_ORG_FULFILLED,
  JOIN_ORG_REJECTED,
  LOAD_NEW_ORG_START,
  LOAD_NEW_ORG_FULFILLED,
  LOAD_NEW_ORG_REJECTED,
} from './actionTypes';

const initialState = {
  isLoading: false,
  error: null,
  joinSuccess: false,
};

const joinUiReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORG_DATA_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_ORG_DATA_FULFILLED:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case FETCH_ORG_DATA_REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case JOIN_ORG_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case JOIN_ORG_FULFILLED:
      return {
        ...state,
        isLoading: false,
        joinSuccess: true,
        error: null,
      };

    case JOIN_ORG_REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case LOAD_NEW_ORG_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case LOAD_NEW_ORG_FULFILLED:
      return {
        ...state,
        isLoading: false,
        joinSuccess: false,
        error: null,
      };

    case LOAD_NEW_ORG_REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default joinUiReducer;
